import { usePageProps } from '@/providers/PagePropsProvider';
import { type PropertyExposePageProps } from '@/pages/[marketCountryCode]/[locale]/exposes/[listingId]';

export const useExposePageProps = () => usePageProps<PropertyExposePageProps>();
